import { filter, flatten, map, mergeAll, pipe } from 'ramda';

import { CMSGameCover } from 'api/cms/gameCovers';
import { GameCovers } from 'contexts/addons/index';
import { BonusGroup, BonusItemGeneral } from 'api/cms/bonuses';

export const sortCovers = (covers: CMSGameCover[]): GameCovers => {
  return pipe<CMSGameCover[], GameCovers[], GameCovers>(
    map(({ gameId, cover }) => ({
      [gameId]: { cover },
    })),
    mergeAll
  )(covers);
};

export const bonusesToDepositCodes = (
  bonuses: BonusItemGeneral[]
): string[] => {
  return pipe<BonusItemGeneral[], BonusItemGeneral[], string[]>(
    filter((bonus: BonusItemGeneral) => !!bonus.code),
    map(({ code }) => code || '')
  )(bonuses);
};

export const bonusGroupsToDepositCodes = (bonuses: BonusGroup[]): any[] => {
  return pipe<BonusGroup[], BonusItemGeneral[][], string[][], string[]>(
    map(({ bonuses }) => bonuses),
    map(bonusesToDepositCodes),
    flatten
  )(bonuses);
};
